export default __webpack_public_path__ + "static/media/Bracers of the Judgment Bolt.9df6735f.jpg";